<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :setLoading="setLoading"
    :persistenceKey="'bank-account-list'"
    :rowClick="rowClickCallBack"
    :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
    :gcPopupBankTransferConfig="gcPopupBankTransferConfig"
    :gcPopupConfig="gcPopupConfig"
    ref="bank-account-list"
  />
  <!-- :persistenceKey="'bank-account-list'" -->
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionListTemplate from "../../../templates/transaction-list.vue";
import { BankTransferService } from "../../../_services/api/finance/bank-transfer.service.js";
import { FeatureStorage } from "../../../_services/storage/index.js";
import { BankAccountsServices } from "../../../_services/api/finance/bankAccounts.js";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { getDefaultUserSettings } from "../../../_store/helpers.js";
import { GLFactorService } from "../../../_services/api/gl/gl-factor.service.js";
import { ForeignCurrencyService } from "../../../_services/api/settings/accounting/foreign-currency.service.js";
import {
  BankTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/finance/bank-tabs.js";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  props: {},
  async created() {
    await this.initialized();
  },
  data() {
    return {
      bankTransferModalVisible: false,
      setLoading: false,
      gcSundryTransactionPopupVisible: false,
      selectorPopup: undefined,
      CellValueChanged: false,
      gcPopupVisible: false,
      AccountNo: undefined,
      BSBNO: undefined,
      BankAccountCode: undefined,
      AccountName: undefined,
      DateInMin: null,
      DateInMax: null,
      CalculatedSecondaryText: undefined,
      BankListDataSource: [],
      RestateBankBalanceModel: {
        AccountNo: undefined,
        DateIn: new Date(),
        FXBookBalance: 0,
        BookBalance: 0,
        ExchangeRate: 1,
        NewBalance: 0,
        GainOrLoss: 0,
        VarianceAccount: undefined,
        Comment: undefined,
        FxCurrencyCode: undefined,
      },
      VarianceGLAccountCode: undefined,
      FXCurrency: undefined,
      ExchangeRate: undefined,
    };
  },
  methods: {
    showBankTransferModal() {
      this.bankTransferModalVisible = true;
    },
    bankTransferCallback(bankTransferCreated) {
      this.bankTransferModalVisible = false;
      if (bankTransferCreated) {
        this.$refs["bank-account-list"].$refs[
          "transactionListGrid"
        ].gridRepaint();
      }
    },
    showValidationSummary(val) {
      if (val.length > 0) {
        this.displayValidationSummary(val);
      }
    },
    gcPopupOnSaveCallBack() {
      this.$refs["bank-account-list"].$refs[
        "transactionListGrid"
      ].gridRepaint();
    },
    async initialized() {
      this.setLoading = true;
      this.setLoading = false;
    },
    visibleGcSundryTransactionPopup(e) {
      this.AccountNo = e.AccountNo;
      this.BSBNO = e.BsbNo;
      this.BankAccountCode = e.Code;
      this.AccountName = e.AccountName;
      this.gcSundryTransactionPopupVisible = true;

      this.FXCurrency = e.CurrencyCode;
      this.ExchangeRate = e.ExchangeRate;
    },
    gcSundryTransactionPopupCallBack() {
      this.gcSundryTransactionPopupVisible = false;
    },
    rowClickCallBack(e) {
      if (e.column.screenField != "GridRecordEllipsisMenu") {
        this.onRowClicked(e, {
          view: this,
          page: "bank-accounts-transaction",
          mode: "review",
          idProperty: "Code",
        });
      }
    },
    navigateToManageBankRecord(recordDetails) {
      this.$router.push({
        path: `/bank-accounts/review/${recordDetails.Code}`,
      });
    },
    navigateBankReconcile(recordDetails) {
      this.$router.push({
        path: `/bank-reconciliation/edit/${recordDetails.Code}`,
        query: {
          from: "bank-account-list",
        },
      });
    },
    gcPopupCallBack() {
      this.gcPopupVisible = false;
      this.CellValueChanged = false;

      this.RestateBankBalanceModel = {
        AccountNo: undefined,
        DateIn: new Date(),
        FXBookBalance: 0,
        BookBalance: 0,
        ExchangeRate: 1,
        NewBalance: 0,
        GainOrLoss: 0,
        VarianceAccount: undefined,
        Comment: undefined,
        FxCurrencyCode: undefined,
      };
    },

    async onGcPopUpUpdate(e) {
      this.gcPopupCallBack();
      var payload = {
        SourceBankAccount: e.FromBank,
        DestinationBankAccount: e.ToBank,
        TransferAmount: e.FXAmount,
        Comment: e.Comments,
        TransferDate: new Date(e.Date).toSaveDate(),
      };
      this.setLoading = true;
      await BankTransferService.saveBankTransferService(payload)
        .then((res) => {
          if (res) this.setLoading = false;

          this.$notify(
            `Bank Transfer #${res.data.Code}  Successfully Updated`,
            "success"
          );

          this.$refs["bank-account-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Save Failed.",
            time: new Date().getTime(),
          };
        });
    },
    async setActiveAccountingPeriod() {
      BankTransferService.getActiveAccountPeriod().then(({ data }) => {
        this.DateInMin = data.value[0].DateStart;
        this.DateInMax = data.value[0].DateEnd;
      });
    },

    bankRecordPostProcess(data) {
      data.forEach((element) => {
        element.CalculatedSecondaryText = `${element.BsbNo} ${element.AccountNo}`;
      });
      return data;
    },
    async visibleGcPopUp() {
      // data
      this.setLoading = true;
      this.CellValueChanged = true;
      this.newBankTransferModel = {
        CalculatedSecondaryText: undefined,
        FromBank: undefined,
        ToBank: undefined,
        BtAmount: 0,
        Comments: undefined,
        Date: new Date(),
      };

      // this.NewDueDate.Min = data.DateIn;

      this.setLoading = false;
      if (!this.DateInMin || !this.DateInMax)
        await this.setActiveAccountingPeriod();

      if (this.BankListDataSource.length == 0)
        await BankAccountsServices.getCustomData({
          url: "BankRecord",
          filter: "Inactive eq 'N'",
          orderby: "AccountName asc",
        })
          .then((res) => {
            this.BankListDataSource = res.data.value;
          })
          .catch((err) => {
            if (err) this.BankListDataSource = [];
          });

      this.gcPopupVisible = true;
      (this.selectorPopup = "Transfer"), (this.bankTransferModalVisible = true);
    },
    async visibleRestateBankBalance(e) {
      this.setLoading = true;
      if (!this.VarianceGLAccountCode)
        await GLFactorService.getByCode(43).then((res) => {
          this.VarianceGLAccountCode = res.data.value[0].GLChartCode;
        });

      this.RestateBankBalanceModel.AccountNo = e.Code;
      this.RestateBankBalanceModel.FXBookBalance = e.FXBookBalance;
      this.RestateBankBalanceModel.BookBalance = e.BookBalance;
      this.RestateBankBalanceModel.ExchangeRate = e.ExchangeRate;
      this.RestateBankBalanceModel.NewBalance = e.BookBalance;
      this.RestateBankBalanceModel.VarianceAccount = this.VarianceGLAccountCode;
      this.RestateBankBalanceModel.FxCurrencyCode = e.CurrencyCode;

      let currency = await ForeignCurrencyService.getByCode(e.CurrencyCode);

      if (currency && currency.data.value.length > 0) {
        this.RestateBankBalanceModel.ExchangeRate =
          currency.data.value[0].GroupRate;
      }

      this.selectorPopup = "RestateBankBalance";
      if (!this.DateInMin || !this.DateInMax)
        await this.setActiveAccountingPeriod();

      if (this.BankListDataSource.length == 0)
        await BankAccountsServices.getCustomData({
          url: "BankRecord",
          filter: "Inactive eq 'N'",
          orderby: "AccountName asc",
        })
          .then((res) => {
            this.BankListDataSource = res.data.value;
          })
          .catch((err) => {
            if (err) this.BankListDataSource = [];
          });

      this.setLoading = false;
      this.gcPopupVisible = true;
    },
    async updateReStateBookBalance() {
      this.setLoading = true;
      await BankAccountsServices.saveRestateBookBalance({
        AccountNo: this.RestateBankBalanceModel.AccountNo,
        DateIn: new Date(this.RestateBankBalanceModel.DateIn).toSaveDate(),
        BookBalance: this.RestateBankBalanceModel.BookBalance,
        FXBookBalance: this.RestateBankBalanceModel.FXBookBalance,
        Comment: this.RestateBankBalanceModel.Comment,
        ExchangeRate: this.RestateBankBalanceModel.ExchangeRate,
        GainOrLoss: this.RestateBankBalanceModel.GainOrLoss,
        NewBalance: this.RestateBankBalanceModel.NewBalance,
        VarianceAccount: this.RestateBankBalanceModel.VarianceAccount,
      })
        .then((res) => {
          this.setLoading = false;
          this.gcPopupCallBack();

          let accountName = this.BankListDataSource.find(
            (x) => x.Code == res.data.AccountNo
          ).AccountName;

          this.$notify(
            `Bank Account ${accountName} has been successfully restated and Journal ${res.data.JournalCode} has been created.`,
            "success"
          );

          this.$refs["bank-account-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Save Failed.",
            time: new Date().getTime(),
          };
        });
    },

    getRestateBankBalanceFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "BankAccount",
                  dataField: "AccountNo",
                  required: true,
                  label: {
                    text: "Bank",
                  },
                  editorOptions: {
                    allowUpdate: true,
                    search: true,
                    // dropDownOptions: {
                    //   minWidth: 500,
                    // },

                    onValueChanged: (e) => {
                      var itemData = this.BankListDataSource.find(
                        (x) => x.Code == e.value
                      );

                      if (itemData) {
                        this.RestateBankBalanceModel.AccountNo = itemData.Code;
                        this.RestateBankBalanceModel.FXBookBalance =
                          itemData.FXBookBalance;
                        this.RestateBankBalanceModel.BookBalance =
                          itemData.BookBalance;
                        this.RestateBankBalanceModel.ExchangeRate =
                          itemData.ExchangeRate;
                        this.RestateBankBalanceModel.NewBalance =
                          itemData.BookBalance;
                        this.RestateBankBalanceModel.VarianceAccount =
                          this.VarianceGLAccountCode;
                        this.RestateBankBalanceModel.FxCurrencyCode =
                          itemData.CurrencyCode;
                      }
                    },
                  },
                  valueExpr: "Code",
                  dataSourceConfig: {
                    data: this.BankListDataSource.filter(
                      (x) =>
                        x.CurrencyCode != getDefaultUserSettings().CurrencyCode
                    ),
                  },
                  itemTemplate: "Record",
                  cellTemplateRecord: {
                    primary: [
                      {
                        dataField: "AccountName",
                        position: "append",
                      },
                    ],
                    secondary: [
                      {
                        dataField: "BsbNo",
                        position: "append",
                      },
                      {
                        dataField: "AccountNo",
                        position: "append",
                      },
                    ],
                  },
                },

                {
                  screenField: "DateIn",
                  dataField: "DateIn",
                  required: "true",
                  label: {
                    text: "Date",
                  },
                  editorOptions: {
                    allowUpdate: true,
                    min: this.DateInMin,
                    max: this.DateInMax,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "Balance",
                  dataField: "FXBookBalance",
                  label: {
                    text: `Balance (${this.RestateBankBalanceModel.FxCurrencyCode})`,
                  },
                },
                {
                  screenField: "Balance",
                  dataField: "BookBalance",
                  label: {
                    text: `Balance (${getDefaultUserSettings().CurrencyCode})`,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "ExchangeRate",
                  dataField: "ExchangeRate",
                  editorOptions: {
                    min: 0,
                    allowUpdate: true,
                    onValueChanged: (e) => {
                      if (!e.event) return;
                      this.CellValueChanged = true;
                      this.RestateBankBalanceModel.ExchangeRate = e.value;

                      if (e.value != 0) {
                        this.RestateBankBalanceModel.NewBalance = (
                          this.RestateBankBalanceModel.FXBookBalance / e.value
                        ).roundNumber(2);
                        this.RestateBankBalanceModel.GainOrLoss = (
                          this.RestateBankBalanceModel.NewBalance -
                          this.RestateBankBalanceModel.BookBalance
                        ).roundNumber(2);
                      } else {
                        this.RestateBankBalanceModel.NewBalance = 0;
                        this.RestateBankBalanceModel.GainOrLoss = 0;
                      }
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                },
                {
                  screenField: "Balance",
                  dataField: "NewBalance",
                  label: {
                    text: `New Balance (${
                      getDefaultUserSettings().CurrencyCode
                    })`,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "Balance",
                  dataField: "GainOrLoss",
                  label: {
                    text: `Gain / Loss (${
                      getDefaultUserSettings().CurrencyCode
                    })`,
                  },
                },
                {
                  screenField: "VarianceGLAccountCode",
                  dataField: "VarianceAccount",
                  label: {
                    text: "Variance Account",
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  // screenField: "Comments",
                  dataField: "Comment",
                  label: {
                    text: "Comment",
                  },
                  editorOptions: {
                    allowUpdate: true,
                    onValueChanged: (e) => {
                      if (!e.event) return;
                      this.RestateBankBalanceModel.Comment = e.value;
                      this.CellValueChanged = true;
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
  computed: {
    gcSundryTransactionPopupConfig() {
      return {
        gcPopupVisible: this.gcSundryTransactionPopupVisible,
        gcPopupCallBack: this.gcSundryTransactionPopupCallBack,
        parentScreen: "bank-account-list",
        onSaveCallBack: this.gcPopupOnSaveCallBack,
        init: this.initialized,
        dataModel: {
          AccountNo: this.AccountNo,
          BSBNO: this.BSBNO,
          BankAccountCode: this.BankAccountCode,
          FXCurrency: this.FXCurrency,
          ExchangeRate: this.ExchangeRate,
        },
        formOptions: {
          gcLabelLocation: "left",
        },
        titleLines: [`${this.AccountName}`, `${this.BSBNO} ${this.AccountNo}`],
      };
    },
    gcPopupBankTransferConfig() {
      return {
        visible: this.bankTransferModalVisible,
        callback: this.bankTransferCallback,
      };
    },
    gcPopupConfig() {
      if (this.selectorPopup == "Transfer") {
        return {
          title: "Bank Transfer",
          dataModel: this.newBankTransferModel,
          callBack: this.gcPopupCallBack,
          gcPopupVisible: this.gcPopupVisible,
          formOptions: {
            gcLabelLocation: "left",
          },
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "BankAccount",
                      dataField: "FromBank",
                      required: true,
                      label: {
                        text: "From Bank",
                      },
                      editorOptions: {
                        allowUpdate: true,
                        search: true,
                        // dropDownOptions: {
                        //   minWidth: 500,
                        // },
                      },
                      dataSourceConfig: {
                        data: this.BankListDataSource.filter(
                          (x) =>
                            x.ComputedCode != this.newBankTransferModel.ToBank
                        ),
                      },
                      itemTemplate: "Record",
                      cellTemplateRecord: {
                        primary: [
                          {
                            dataField: "AccountName",
                            position: "append",
                          },
                        ],
                        secondary: [
                          {
                            dataField: "BsbNo",
                            position: "append",
                          },
                          {
                            dataField: "AccountNo",
                            position: "append",
                          },
                        ],
                      },
                    },
                    {
                      screenField: "BankAccount",
                      dataField: "ToBank",
                      required: true,
                      label: {
                        text: "To Bank",
                      },
                      editorOptions: {
                        allowUpdate: true,
                      },

                      editorTemplate: {
                        primary: [
                          {
                            dataField: "AccountName",
                          },
                        ],
                        secondary: [
                          {
                            dataField: "Code",
                          },
                        ],
                      },
                      dataSourceConfig: {
                        data: this.BankListDataSource.filter(
                          (x) =>
                            x.ComputedCode != this.newBankTransferModel.FromBank
                        ),
                      },
                      itemTemplate: "Record",
                      cellTemplateRecord: {
                        primary: [
                          {
                            dataField: "AccountName",
                            position: "append",
                          },
                        ],
                        secondary: [
                          {
                            dataField: "BsbNo",
                            position: "append",
                          },
                          {
                            dataField: "AccountNo",
                            position: "append",
                          },
                        ],
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "Date",
                      required: "true",
                      label: {
                        text: "Date",
                      },
                      // default: new Date(),

                      editorOptions: {
                        allowUpdate: true,
                        min: this.DateInMin,
                        max: this.DateInMax,
                      },
                    },

                    {
                      screenField: "FXAmount",
                      // dataField: "BtAmount",
                      required: true,

                      // label: {
                      //   text: "Amount",
                      // },
                      editorOptions: {
                        min: 0,
                        max: 999999,
                        allowUpdate: true,
                      },
                      validationRules: [
                        {
                          type: "custom",

                          validationCallback: ({ value, rule }) => {
                            rule.message = `Amount should be greater than 0`;
                            return value > 0;
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  items: [
                    {
                      // screenField: "Comments",
                      dataField: "Comments",
                      label: {
                        text: "Comment",
                      },
                      editorOptions: {
                        allowUpdate: true,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          save: {
            text: "Save",
            clickCallback: async (e) => {
              if (this.CellValueChanged) {
                let confirmSaveing = await this.$confirm(
                  "Do you want to continue with this bank transfer ?",
                  "Bank Transfer Confirmation"
                );

                if (confirmSaveing) {
                  this.onGcPopUpUpdate(e);
                }
              }
            },
          },
          back: {
            text: "Cancel",
            clickCallback: async () => {
              if (this.CellValueChanged) {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave ?",
                  "Unsaved Changes"
                );

                if (confirmLeaving) {
                  this.gcPopupCallBack();
                }
              }

              // this.gcPopupCallBack();
            },
          },
        };
      } else if (this.selectorPopup == "RestateBankBalance") {
        return {
          title: "Re-State Book Balance",
          dataModel: this.RestateBankBalanceModel,
          callBack: this.gcPopupCallBack,
          gcPopupVisible: this.gcPopupVisible,
          formOptions: {
            gcLabelLocation: "left",
          },
          items: this.getRestateBankBalanceFormItems(),
          save: {
            text: "Save",
            disabled: !this.CellValueChanged,
            clickCallback: async (e) => {
              if (this.CellValueChanged) {
                let confirmSaveing = await this.$confirm(
                  "Do you want to continue with this Re-State Book Balance ?",
                  "Re-State Book Balance Confirmation"
                );

                if (confirmSaveing) {
                  this.updateReStateBookBalance(e);
                }
              }
            },
          },
          back: {
            text: "Cancel",
            clickCallback: async () => {
              if (this.CellValueChanged) {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave ?",
                  "Unsaved Changes"
                );

                if (confirmLeaving) {
                  this.gcPopupCallBack();
                }
              } else this.gcPopupCallBack();
            },
          },
          popupWidth: "50%",
        };
      } else return {};
    },
    setScreenConfig() {
      var config = {
        title: "Bank Accounts",
        ScreenName: "Bank Accounts - All",
        selectedIndex: GetIndexByTabName("All"),
        tabs: BankTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BankRecord",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.bankRecordPostProcess,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Bank Accounts",
                message: "Get Started, Add a Bank Account",
              },
            },
          },
          toolbar: {
            export: false,
            openFilter: true,
            search: false,
            columnChooser: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/bank-accounts/create",
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Account",
              gridDataField: "AccountName",
              dataField: "AccountName",
              label: "Account",
              sortOrder: "asc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.BankAccount.minWidth,
              width: "auto",
              showInColumnChooser: true,
              cellTemplate: "RecordTwoLines",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "AccountName",
                  },
                ],
                secondary: [
                  {
                    dataField: "CalculatedSecondaryText",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "AccountName",
                  label: "Account Name",
                  showInColumnChooser: true,
                },
                {
                  dataField: "AccountNo",
                  label: "Account Number",
                  showInColumnChooser: false,
                },
                {
                  dataField: "BsbNo",
                  label: "BSB",
                  showInColumnChooser: true,
                },
              ],
              filterIndex: 0,
              filterDataField: "AccountSearchText",
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "BankAccountName",
              dataField: "CompanyBank",
              label: "Bank",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              minWidth: 80,
            },
            {
              screenField: "BankAccountNo",
              dataField: "ComputedControlAccount",
              label: "GL Account",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.AccountCode.width,
              allowSearch: true,
            },
            {
              screenField: "Balance",
              dataField: "BookBalance",
              label: "Book Balance",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
            },
            {
              screenField: "CurrencyCode",
              dataField: "CurrencyCode",
              gridDataField: "CurrencyCode",
              label: "Currency",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.AccountCode.width,
            },
            {
              screenField: "Currency",
              dataField: "CurrencyCode",
              gridDataField: "CurrencyCode",
              label: "Currency",
              allowSorting: true,
              showInColumnChooser: false,
              visible: false,
              filterIndex: 1,
            },
            {
              screenField: "FXBookBalance",
              dataField: "FXBookBalance",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.BankAccountAmount.width,
            },
            {
              screenField: "Total",
              dataField: "FXOutstandingPaymentTotal",
              label: "O/S Payts (FX)",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.BankAccountAmount.width,
            },
            {
              screenField: "FXTotal",
              dataField: "FXOutstandingReceiptTotal",
              label: "O/S Receipts (FX)",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.BankAccountAmount.width,
            },
            {
              screenField: "FXBalance",
              dataField: "AccountBalance",
              label: "Account Balance (FX)",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              allowSearch: false,
              width: ColumnWidth.BankAccountAmount.width,
            },
            {
              screenField: "FXLineTotal",
              dataField: "LastReconciledAmount",
              label: "Reconciled Balance (FX)",
              allowSorting: true,
              allowSearch: false,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.BankAccountAmount.width,
            },

            {
              screenField: "Date",
              dataField: "LastReconciledDate",
              label: "Reconciled Date",
              allowSearch: false,
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.Date.width,
            },
            {
              screenField: "Balance",
              dataField: "BookBalance",
              label: "GCORP Balance (Base Currency)",
              allowSorting: true,
              allowSearch: false,
              showInColumnChooser: true,
              visible: true,
              width: ColumnWidth.BankAccountAmount.width,
            },

            {
              screenField: "BankBranch",
              dataField: "BankBranch",
              label: "Branch",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
            },
            {
              screenField: "ExportCode",
              dataField: "ExportCode",
              label: "Export Code",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
            },
            {
              screenField: "UserBank",
              dataField: "UserBank",
              label: "User Bank",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
            },
            {
              screenField: "AbaUserCode",
              dataField: "AbaUserCode",
              label: "ABA Code",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
            },
            {
              screenField: "Date",
              dataField: "OpeningBalanceDate",
              label: "Reconcile From",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
            },
            {
              screenField: "OpeningBalance",
              dataField: "FXOpeningBalance",
              label: "Opening Balance (FX)",
              allowSorting: true,
              showInColumnChooser: true,
              visible: false,
              width: ColumnWidth.BankAccountAmount.width,
            },
            {
              screenField: "Date",
              dataField: "DateChanged",
              label: "Date Changed",
              allowSorting: true,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "Date",
              dataField: "ChangedBy",
              label: "Changed By",
              allowSorting: true,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "Status",
              allowSorting: true,
              // label: "Status",
              allowSearch: true,
              showInColumnChooser: true,
              filterIndex: 2,

              filterDefaultValue: ["N"],
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              width: 50,
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Manage",
                      data: data,
                      clickAction: (recordDetails) =>
                        this.navigateToManageBankRecord(recordDetails),
                      visible: true,
                    },
                    {
                      menuText: "Transfer",
                      data: data,
                      clickAction: this.showBankTransferModal,
                      visible: FeatureStorage.checkPermission(
                        "BankTransfer",
                        "create"
                      ),
                    },
                    {
                      menuText: "New Transaction",
                      data: data,
                      clickAction: (e) =>
                        this.visibleGcSundryTransactionPopup(e),
                      visible: FeatureStorage.checkPermission(
                        "BankTransactions",
                        "create"
                      ),
                    },
                    {
                      menuText: "Reconcile",
                      data: data,
                      clickAction: (e) => this.navigateBankReconcile(e),
                      visible: FeatureStorage.checkPermission(
                        "BankTransactions",
                        "create"
                      ),
                    },
                    {
                      menuText: "Re-State Balance",
                      data: data,
                      clickAction: (e) => this.visibleRestateBankBalance(e),
                      visible: FeatureStorage.checkPermission(
                        "BankReconciliation",
                        "create"
                      ),
                      disabled:
                        data.data.CurrencyCode ==
                        getDefaultUserSettings().CurrencyCode,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: false,

              // visible:
            },
          ],
        },
      };
      return config;
    },
  },
};
</script>
<style lang="scss"></style>
